export enum ShareType {
  NATIVE,
  SMS,
  MAIL,
}

export type ShareProps = {
  title: string;
  text: string;
};

export const shareViaSMS = (body: string) => {
  window.open("sms:&body=" + body, "_self");
};

export const shareViaMail = (subject: string, body: string) => {
  window.open("mailto:?subject=" + subject + "&body=" + body, "_self");
};

export const shareViaTwitter = (body: string, url: string) => {
  window.open("https://twitter.com/intent/tweet?text=" + body + "&url=" + url);
};

export const shareViaFacebook = (body: string, url: string) => {
  window.open(
    "https://facebook.com/sharer/sharer.php?u=" + url + "&quote" + body
  );
};

export const shareViaLinkedin = (url: string) => {
  window.open("https://linkedin.com/sharing/share-offsite/?url=" + url);
};

export const shareViaWhatsApp = (body: string) => {
  window.open("https://wa.me/?text=" + body);
};

export const shareViaInstagram = () => {
  window.open("instagram://");
};

//very new native share dialog
export const shareDialog = (title: string, text: string) => {
  if (navigator.share) {
    navigator
      .share({
        title: title,
        text: text,
        url: process.env.PUBLIC_URL,
      })
      .catch((e) => console.log(e));
  } else {
  }
};

export function copyToClipboard(string: string) {
  let textarea;
  let result;

  try {
    textarea = document.createElement("textarea");
    textarea.setAttribute("readonly", "true");
    textarea.setAttribute("contenteditable", "true");
    textarea.style.position = "fixed"; // prevent scroll from jumping to the bottom when focus is set.
    textarea.value = string;

    document.body.appendChild(textarea);

    textarea.focus();
    textarea.select();

    const range = document.createRange();
    range.selectNodeContents(textarea);

    const sel = window.getSelection();
    sel?.removeAllRanges();
    sel?.addRange(range);

    textarea.setSelectionRange(0, textarea.value.length);
    result = document.execCommand("copy");
  } catch (err) {
    console.error(err);
    result = null;
  } finally {
    if (textarea) {
      document.body.removeChild(textarea);
    }
  }

  // manual copy fallback using prompt
  if (!result) {
    const isMac = navigator.platform.toUpperCase().indexOf("MAC") >= 0;
    const copyHotkey = isMac ? "⌘C" : "CTRL+C";
    result = prompt(`Press ${copyHotkey}`, string); // eslint-disable-line no-alert
    if (!result) {
      return false;
    }
  }
  return true;
}
